import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["recordControls", "fileInput", "error"];

  static values = {
    recordingUrl: String,
  };

  recorderUploaded(event) {
    const { signedId } = event.detail;
    this.replaceRecordingOnServer(signedId);
  }

  recorderUnsupported() {
    if (this.hasRecordControlsTarget) this.recordControlsTarget.classList.add("hidden");
  }

  recorderError(event) {
    if (!this.hasErrorTarget) return;
    this.errorTarget.textContent = event.detail?.message || "";
    this.errorTarget.classList.remove("hidden");
  }

  triggerUpload() {
    if (!this.hasFileInputTarget) return;
    this.fileInputTarget.click();
  }

  async fileSelected() {
    const file = this.fileInputTarget.files[0];
    if (!file) return;

    const recorder = this.findRecorderController();
    if (!recorder) return;

    await recorder.uploadFile(file);
    this.fileInputTarget.value = "";
  }

  findRecorderController() {
    const el = this.element.querySelector("[data-controller~='audio-recorder']");
    if (!el) return null;
    return this.application.getControllerForElementAndIdentifier(el, "audio-recorder");
  }

  async replaceRecordingOnServer(signedId) {
    const url = this.recordingUrlValue;
    if (!url) return;

    const formData = new FormData();
    formData.append("audio_response[recording_signed_id]", signedId);

    const response = await fetch(url, {
      method: "PATCH",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": this.csrfToken(),
      },
      body: formData,
    });

    if (response.ok) {
      const stream = await response.text();
      window.Turbo?.renderStreamMessage(stream);
    }
  }

  csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content || "";
  }
}
